// extracted by mini-css-extract-plugin
module.exports = {"mecha":"index-mecha-3Mejo","btnDetail":"index-btnDetail-3rCZ-","active":"index-active-3nIS6"};